var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalyticsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99996 7.41111L9.49996 3.07518L9.50248 3.07664L12 1.63277L10 0.5L0 6.5V17.5L1.99996 18.9765V7.41111ZM6.25 8.79984L13.5 4.5L20.5 8.5L13 12.5L6.25 8.79984ZM5 10V19L12 22.5L12 14L5 10ZM21.5 18.5L14 22.5V14.5021L21.5 10.5V18.5ZM13.25 2.37498L23.25 8.15619V19.7187L13.25 25.5L3.25 19.7187V8.15619L13.25 2.37498Z",
    fill: "#399E79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsActive);
export default __webpack_public_path__ + "static/media/analyticsActive.64a9b89977cc19292d6a691c5ba20c47.svg";
export { ForwardRef as ReactComponent };